import {axiosReqGet, axiosReqOther} from "./config";
import { store } from '../store/store';

const USER_TOKEN = store.getState().authentication.user;

export const Project = {
    // getPropertyTypes,
    getProject,
    getFeaturedProjects,
    getFeaturedProjectsWithPagination,
    getProjectTypes,
    getProjectList
}

// function getSelfProperties(){
//     const url = 'property-types/index.json';
//     return axiosReqGet()
//             .get(url)
//             .then(res => {
//             return res; 
//         })
//         .catch(err => { 
//             alert(err.response.data.message)      
//             return err; 
//         })
// }

/**
 * getProject
 * get Project Detail
 * @param {*string} email 
 */
function getProject(data) {
    
    const url = `project/detail.json?project=${data.project}`;
   
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

/**
* getFeaturedProjects
* get featured Projects
* @param {*jsong} data 
*/
function getFeaturedProjects(data) {
   
    const url = `project/get-featured-projects.json`;
   
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

/**
* getProjectList
* get all Projects
* @param {*jsong} data 
*/
function getProjectList(data) {
   
    const url = `project/get-projects.json`;
   
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

/**
 * getProperty
 * get Property Detail
 * @param {*string} email 
 */
function getProjectTypes() {
    
    const url = 'project/types.json';
    return axiosReqGet()
            .get(url)
            .then(res => {
            return res; 
        })
        .catch(err => { 
            alert(err.response.data.message)      
            return err; 
        })
}


/**
* getFeaturedPropertiesWithPagination
* get related Properties
* @param {*jsong} data 
*/
function getFeaturedProjectsWithPagination(data) {
   
    const url = `property/get-featured-properties.json`;
   
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}


export default Project;